import * as React from 'react';

import Help16 from './Help16';

export const help16 = () => <Help16 />;

export default {
    title: 'Icon/Line/Help16',
    component: Help16,
    parameters: {
        notes: "`import Help16 from 'box-ui-elements/es/icon/line/Help16';`",
    },
};
